module.exports = __webpack_public_path__ + "bbc22e414bad33de0d15531e95a2cf3f.svg";